<template>
	<tr>
		<th width="30%" class="font-weight-bold" :style="{ ...thStyle, fontSize }">
			<slot name="column" :columnName="columnName">
				{{ columnName }}
				<v-icon class="float-right" v-if="showHistoryIcon">mdi-clock-edit-outline</v-icon>
			</slot>
		</th>

		<slot name="td">
			<v-hover v-if="showEditBtnOnHover" v-slot="{ hover }" close-delay="200" open-delay="200">
				<td width="70%" class="no-wrap" :style="{ ...tdStyle, fontSize }">
					<slot name="value" :value="formatByDateType()">
						<template v-if="text">
							<p v-text="formatByDateType()" :style="{ ...pStyle, fontSize }" />
						</template>
						<template v-else-if="html">
							<p v-html="formatByDateType()" :style="{ ...pStyle, fontSize }" />
						</template>
						<template v-else> {{ formatByDateType() }}</template>
					</slot>
					<slot name="edit-btn">
						<v-icon v-if="hover" class="float-right" @click="$emit('open-edit-dialog')"
							>mdi-pencil-box</v-icon
						>
					</slot>
				</td>
			</v-hover>

			<td v-else width="70%" class="no-wrap" :style="{ ...tdStyle, fontSize }">
				<slot name="value" :value="formatByDateType()">
					<template v-if="text">
						<p v-text="formatByDateType()" :style="{ ...pStyle, fontSize }" />
					</template>
					<template v-else-if="html">
						<p v-html="formatByDateType()" :style="{ ...pStyle, fontSize }" />
					</template>
					<template v-else> {{ formatByDateType() }}</template>
				</slot>
				<slot name="edit-btn">
					<v-icon v-if="showEditBtn" class="float-right" @click="$emit('open-edit-dialog')"
						>mdi-pencil-box</v-icon
					>
				</slot>
			</td>
		</slot>
	</tr>
</template>

<script>
import common from "../../helper/common.js"

export default {
	props: {
		// thに表示される文字列
		columnName: {
			type: String,
			required: true,
		},
		value: {
			type: null,
			required: false,
		},
		// 日付整形用にdataTypeを指定する
		dataType: {
			type: String,
			required: false,
			default: null,
		},
		// テキストとして表示するか pタグで囲む
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
		// htmlとして表示するか
		html: {
			type: Boolean,
			required: false,
			default: false,
		},
		// 履歴アイコンを表示するか
		showHistoryIcon: {
			type: Boolean,
			required: false,
			default: false,
		},
		// 編集アイコンを常に表示するか
		showEditBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		// マウスオーバーで編集アイコンを表示するか
		showEditBtnOnHover: {
			type: Boolean,
			required: false,
			default: false,
		},
		thStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		tdStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		pStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		fontSize: {
			type: String,
			required: false,
			default: "",
		},
	},
	data() {
		return {
			common: common,
		}
	},
	methods: {
		formatByDateType() {
			if (this.dataType == "date") {
				return common.formatDate(this.value)
			} else if (this.dataType == "datetime") {
				return common.formatDateTime(this.value)
			} else if (this.dataType == "time") {
				return common.formatTime(this.value)
			} else {
				return this.value
			}
		},
	},
}
</script>
